import Bugsnag from '@bugsnag/js';

window.exceptionReporting = ({ apiKey, enabledReleaseStages, releaseStage, appVersion, context }) => {
  const ignoredErrors = [
    'unhandledrejection handler received a non-error',
  ];

  Bugsnag.start({
    apiKey: apiKey,
    enabledReleaseStages: enabledReleaseStages,
    releaseStage: releaseStage,
    appVersion: appVersion,
    onError: function (event) {
      var error = event.errors[0] || {};

      if (error.errorMessage && ignoredErrors.some(e => error.errorMessage.includes(e))) return false;

      // Add additional diagnostic information
      event.addMetadata('context', JSON.parse(atob(context)))
    }
  });
};
